import Vue from 'vue'
import Vuex from 'vuex'

import rwd from './rwd'
import user from './user'
import theme from './theme'
import auth from './auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    rwd,
    user,
    theme,
    auth
  }
})
